export default {
  site_name: "YOYBUY.boats",
  tagline: "Интеллектуальные спредшиты для сорсинга из Китая",
  nav_home: "Главная",
  nav_categories: "Категории",
  nav_articles: "Статьи",
  nav_about: "О системе",
  btn_yoybuy_sheet: "yoybuy sheet",
  btn_buy_now: "купить сейчас",
  btn_read_article: "Читать статью →",
  btn_back_home: "← На главную",
  hero_label: "(YOYBUY Sheet System)",
  hero_title_line1: "Интеллектуальные спредшиты",
  hero_title_line2: "для сорсинга из Китая",
  hero_subtitle: "Получите доступ к проверенной системе поиска товаров. Анализируйте рынок, сравнивайте поставщиков и увеличивайте маржинальность вашего бизнеса с помощью наших профессиональных таблиц.",
  section_categories_title: "Популярные категории",
  section_categories_subtitle: "Товары для дропшиппинга и ресейла",
  section_all_categories_title: "Все категории товаров",
  section_article_label: "(SEO Guide)",
  section_article_title: "YOYBUY Sheet: Полное руководство по трендовым товарам 2026",
  section_article_quote: "Наша система спредшитов позволяет находить товары с наценкой до 300%, анализировать тренды и опережать конкурентов на рынке дропшиппинга.",
  section_article_author: "Редакция YOYBUY",
  section_system_label: "О системе",
  section_system_title: "Почему тысячи реселлеров выбирают YOYBUY Sheet для закупок в Китае",
  section_system_desc: "Мы создали профессиональную систему аналитики поставщиков, которая ежедневно обновляется и содержит актуальные цены, контакты производителей и анализ трендов. Наши спредшиты экономят до 70% времени на поиск товаров и помогают избежать типичных ошибок при работе с китайскими поставщиками.",
  cta_title: "начни закупку с yoybuy sheet",
  cta_desc_line1: "Полный доступ к таблицам поставщиков.",
  cta_desc_line2: "Ежедневное обновление цен.",
  footer_subscribe_title: "ПОДПИСКА",
  footer_subscribe_placeholder: "Ваш email",
  footer_subscribe_hint: "Получайте обновления о новых спредшитах и трендах. ",
  footer_subscribe_hint_link: "Вернуться на главную",
  footer_categories_title: "КАТЕГОРИИ",
  footer_contacts_title: "КОНТАКТЫ",
  footer_desc_line1: "YOYBUY.boats — ваш навигатор",
  footer_desc_line2: "в мире закупок из Китая.",
  footer_desc_line3: "Профессиональные спредшиты",
  footer_desc_line4: "для дропшиппинга и ресейла.",
  article_meta_date: "5 июля 2026",
  article_meta_author: "Редакция YOYBUY",
  article_title: "YOYBUY Sheet: Как находить трендовые товары из Китая с прибылью до 300%",
  article_intro_p1: "В мире электронной коммерции доступ к правильной информации определяет успех бизнеса. Система спредшитов YOYBUY Sheet создана именно для этого — предоставить реселлерам и дропшипперам структурированные данные о товарах, поставщиках и рыночных трендах Китая. В этом руководстве мы подробно разберём, как использовать спредшиты для поиска высокомаржинальных товаров и построения прибыльного бизнеса на перепродаже.",
  article_intro_p2: "Каждый день тысячи предпринимателей ищут способы найти качественные товары по низким ценам для последующей перепродажи. Проблема в том, что большинство новичков теряют время на непроверенных поставщиков и упускают реальные возможности заработка. Наш инструмент решает эту проблему системно.",
  footer_brand: "YOYBUY",
  categories: {
    shoes: "Обувь",
    hoodies: "Худи / Свитера",
    tshirts: "Футболки",
    jackets: "Куртки",
    pants: "Штаны / Шорты",
    headwear: "Головные уборы",
    sets: "Комплекты",
    underwear: "Нижнее бельё",
    jersey: "Джерси",
    accessories: "Аксессуары",
    bags: "Сумки",
    belts: "Ремни",
    perfumes: "Парфюмерия",
    other: "Разное",
  },
  category_descriptions: {
    shoes: "Кроссовки, кеды, ботинки",
    hoodies: "Толстовки, свитшоты",
    tshirts: "Футболки, поло, лонгсливы",
    jackets: "Пуховики, бомберы, ветровки",
    pants: "Джинсы, брюки, шорты",
    headwear: "Кепки, шапки, панамы",
    sets: "Спортивные и повседневные",
    underwear: "Трусы, носки, майки",
    jersey: "Спортивная форма",
    accessories: "Кошельки, чехлы, украшения",
    bags: "Рюкзаки, сумки, клатчи",
    belts: "Кожаные и текстильные",
    perfumes: "Духи, масла, диффузоры",
    other: "Товары разных категорий",
  },
  dropdown_label: "Выберите категорию",
}